import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Img from 'gatsby-image';

import './styles/PostPreview.scss';

const PostPreview = ({ data, image, className }) => {
  const { title, description, date } = data.frontmatter;
  const link = data.fields.slug;

  return (
    <div className={`postPreview ${className}`}>
      <Link to={link}>
        <div className="postPreview-content">
          <div className="postPreview-image">
            <Img sizes={image} />
          </div>
          <div className="postPreview-text">
            <h3 className="postPreview-title">{title}</h3>
            <p className="postPreview-description">{description}</p>
            <p className="postPreview-date">{date}</p>
          </div>
        </div>
      </Link>
      <hr />
    </div>
  );
}

PostPreview.defaultProps = {
  className: '',
  image: {},
}

PostPreview.propTypes = {
  data: PropTypes.object.isRequired,
  image: PropTypes.object,
  className: PropTypes.string,
}

export default PostPreview;





// WEBPACK FOOTER //
// ./src/components/PostPreview.jsx